import { Reveal } from "../components/Reveal";
import { ContactCTA } from "../components/ContactCTA";

const VALUES = [
  { t: "Affidabilità", d: "Squadre puntuali e responsabili, che rispettano i tempi serrati del turnover." },
  { t: "Attenzione ai dettagli", d: "Ogni superficie, ogni angolo, ogni tessuto trattato con cura professionale." },
  { t: "Discrezione", d: "Gestiamo il tuo immobile con la stessa riservatezza con cui tratteremmo il nostro." },
];

export default function ChiSiamo() {
  return (
    <div data-testid="chi-siamo-page">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-44 pb-16">
        <Reveal>
          <div className="overline text-secondary mb-6">Chi siamo</div>
          <h1 className="serif text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter text-primary leading-[0.92] max-w-4xl">
            Al fianco degli host di Roma.
          </h1>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-12 gap-12 items-center">
          <Reveal className="md:col-span-6">
            <div className="overflow-hidden clip-tl">
              <img src="https://images.pexels.com/photos/6466212/pexels-photo-6466212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940"
                   alt="Personale Cleansof al lavoro" className="w-full h-[520px] object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-6">
            <p className="serif text-2xl md:text-3xl font-light text-primary leading-snug mb-6">
              Cleansof nasce a Roma per rispondere a un'esigenza precisa: offrire ai proprietari di case vacanza un partner unico e affidabile.
            </p>
            <p className="font-light text-muted-foreground text-lg leading-relaxed mb-4">
              Uniamo pulizie professionali e noleggio biancheria in un unico servizio coordinato, pensato per il ritmo intenso degli affitti brevi. Ci occupiamo di ogni turnover con precisione, così tu puoi concentrarti sull'accoglienza e sulla crescita della tua attività.
            </p>
            <p className="font-light text-muted-foreground text-lg leading-relaxed">
              Ogni intervento è calibrato sugli standard che i tuoi ospiti si aspettano da un soggiorno nella Città Eterna.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-primary text-primary-foreground">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28">
          <Reveal>
            <div className="overline text-secondary mb-12">I nostri valori</div>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-10">
            {VALUES.map((v, i) => (
              <Reveal key={v.t} delay={i * 0.1}>
                <div className="border-t border-primary-foreground/20 pt-6">
                  <div className="serif text-5xl font-light text-secondary mb-4">0{i + 1}</div>
                  <h3 className="serif text-3xl font-light mb-3">{v.t}</h3>
                  <p className="font-light text-primary-foreground/60 leading-relaxed">{v.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </div>
  );
}
